import {BasicContentPage, getServerSidePropsTemplate} from '@@client/components/BasicContentPage'
import {getTaxFormsPageContent} from '@@client/content/api'

export default BasicContentPage

export const getServerSideProps = getServerSidePropsTemplate(getTaxFormsPageContent)
